import { Briefcase, Buildings } from "iconsax-reactjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import CTAs from "./CTAs";

const AccountType = () => {
  const [selectedBlock, setSelectedBlock] = useState(null);
  const navigate = useNavigate();

  const handleSelect = (type) => {
    // Prevent selecting professional services
    if (type === "block2") return;
    setSelectedBlock(type);
  };

  const handleCTAClick = () => {
    if (selectedBlock) {
      const accountTypeMapping = {
        block1: "business",
        block2: "professional_services",
      };

      navigate("/register1", {
        state: {
          selectedBlock: selectedBlock,
          accountType: accountTypeMapping[selectedBlock],
        },
      });
    }
  };

  return (
    <div className="w-full max-w-[400px] mx-auto flex flex-col items-center">
      <div className="w-full flex gap-4 justify-center">
        {/* Businesses */}
        <div
          onClick={() => handleSelect("block1")}
          className={`flex flex-col items-center justify-center w-1/2 p-6 gap-1.5 border border-solid border-neutrals-neutral-100 rounded-3xs hover:bg-neutrals-white-light cursor-pointer transition-all duration-200
            ${
              selectedBlock === "block1"
                ? "border-primary-primary-500 bg-white text-neutrals-neutral-900 shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)]"
                : "border-neutrals-neutral-100 hover:border-neutrals-neutral-100"
            }`}
        >
          <Buildings
            variant={"Bold"}
            color={selectedBlock === "block1" ? "#2563EB" : "#576E7E"}
            className="mb-2"
          />
          <span
            className={`font-semibold text-sm ${
              selectedBlock === "block1"
                ? "text-primary-primary-500"
                : "text-neutrals-neutral-900"
            }`}
          >
            Businesses
          </span>
        </div>

        {/* Professional Services – Coming soon */}
        <div
          className={`flex flex-col items-center justify-center w-1/2 p-6 border border-solid border-neutrals-border-disable rounded-3xs cursor-not-allowed transition-all duration-200 gap-1.5
            ${
              selectedBlock === "block2"
                ? "border-primary-primary-500 bg-white shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)]"
                : "border-neutrals-border-disable hover:border-neutrals-border-disable"
            }`}
        >
          <Briefcase
            variant="Bold"
            color={selectedBlock === "block2" ? "#2563EB" : "#A4A7AE"}
            className="mb-2"
          />
          <span
            className={`font-semibold text-sm ${
              selectedBlock === "block2"
                ? "text-primary-primary-500"
                : "text-neutrals-text-disable"
            }`}
          >
            Professional Services
          </span>
          <div className="rounded-full bg-primary-primary-50 border-primary-primary-500 border-solid border-[1px] flex items-center justify-center py-0.5 px-2 text-left text-sm text-primary-primary-500">
            <div className="relative font-semibold">Coming soon</div>
          </div>
        </div>
      </div>

      <div className="mt-10 w-full flex justify-center">
        <CTAs
          type={selectedBlock ? "Signinbtn" : "Disabledbtn"}
          text="Continue"
          width="100%"
          onClick={selectedBlock ? handleCTAClick : null}
          disabled={!selectedBlock}
        />
      </div>
    </div>
  );
};

export default AccountType;
